import { render, staticRenderFns } from "./form_cadastrar.vue?vue&type=template&id=91a675e4&scoped=true"
import script from "./form_cadastrar.vue?vue&type=script&lang=js"
export * from "./form_cadastrar.vue?vue&type=script&lang=js"
import style0 from "./form_cadastrar.vue?vue&type=style&index=0&id=91a675e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a675e4",
  null
  
)

export default component.exports